import HomeView from "../views/HomeView.vue";
import RegisterView from "../views/RegisterView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";
import LogoutView from "../views/LogoutView.vue";
import UserParametersView from "../views/UserParametersView.vue";
import ConfirmMailView from "../views/ConfirmMailView.vue";
import ClientListView from "@/views/ClientListView.vue";
import MailAlreadyCheckView from "@/views/MailAlreadyCheckView.vue";
import UserListView from "@/views/UserListView.vue";
import LoginView from "@/views/LoginView.vue";
import LegalView from "@/views/LegalView.vue";
import WhoView from "@/views/WhoView.vue";
import AssistanceView from "@/views/AssistanceView.vue";
import ChooseGroupView from "@/views/ChooseGroupView.vue";
import BusinessListView from "@/views/BusinessListView.vue";
import GroupParametersView from "@/views/GroupParametersView.vue";
import AcceptCGUView from "@/views/AcceptCGUView.vue";
import BusinessSignatureView from "@/views/BusinessSignatureView.vue";
import BusinessByClientListView from "@/views/BusinessByClientListView.vue";
import ProductionView from "@/views/ProductionView.vue";
import PriceView from "@/views/PriceView.vue";
import UnpaidView from "@/views/UnpaidView.vue";

export const coreRoutes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/legal",
    name: "Legal",
    component: LegalView,
  },
  {
    path: "/who",
    name: "Who",
    component: WhoView,
  },
  {
    path: "/tarification",
    name: "Price",
    component: PriceView,
  },
  {
    path: "/assistance",
    name: "Assistance",
    component: AssistanceView,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterView,
  },
  {
    path: "/confirm-mail/:token?",
    name: "ConfirmMail",
    component: ConfirmMailView,
  },
  {
    path: "/accept-cgu",
    name: "AcceptCGU",
    component: AcceptCGUView,
  },
  {
    path: "/choose-group",
    name: "ChooseGroup",
    component: ChooseGroupView,
  },
  {
    path: "/mail-already-check",
    name: "MailAlreadyCheck",
    component: MailAlreadyCheckView,
  },
  {
    path: "/reset-password/:token?",
    name: "ResetPassword",
    component: ResetPasswordView,
  },
  {
    path: "/logout",
    name: "Logout",
    component: LogoutView,
  },
  {
    path: "/businesses",
    name: "BusinessList",
    component: BusinessListView,
  },
  {
    // Les devis envoyés sont maintenant un filtre de la rubrique Devis
    path: "/businesses/active-quotes",
    redirect: "/businesses/quotes",
  },
  {
    // L'ancienne rubrique Factures est devenue la rubrique des factures à encaisser
    path: "/businesses/invoices",
    redirect: "/businesses/unpaid",
  },
  {
    // La rubrique Payés a été retirée
    path: "/businesses/paid",
    redirect: "/businesses/unpaid",
  },
  {
    path: "/businesses/:tab",
    name: "BusinessListTab",
    component: BusinessListView,
  },
  {
    path: "/businesses/unpaid",
    name: "UnpaidView",
    component: UnpaidView,
  },
  {
    path: "/businesses-for-client",
    name: "BusinessByClientList",
    component: BusinessByClientListView,
  },
  {
    path: "/business/signature/:hash?",
    name: "BusinessSignature",
    component: BusinessSignatureView,
  },
  {
    path: "/clients/:tab?",
    name: "ClientList",
    component: ClientListView,
  },
  {
    path: "/dossiers/:id?",
    name: "Dossiers",
    component: ProductionView,
  },
  {
    path: "/users",
    name: "UserList",
    component: UserListView,
  },
  {
    path: "/user-parameters",
    name: "UserParameters",
    component: UserParametersView,
  },
  {
    path: "/group-parameters",
    name: "GroupParameters",
    component: GroupParametersView,
  },
  {
    path: "/:catchAll(.*)",
    component: HomeView,
  },
];